// extracted by mini-css-extract-plugin
export default {"container":"_9EjoN","title":"QCt3i"};